import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { loyaltyMessages } from '../../messages';
import { DescriptionWrapper, LoyaltyButton } from '../../styled';

interface InactiveProps {
  handleOpenDrawerOrModal: () => void;
}

export const Inactive = ({ handleOpenDrawerOrModal }: InactiveProps) => {
  return (
    <DescriptionWrapper>
      <Text typography="labelSmall400" color="text.secondary">
        <FormattedMessage {...loyaltyMessages.joinNotinoClubCta} />
      </Text>

      <LoyaltyButton onClick={handleOpenDrawerOrModal}>
        <FormattedMessage {...loyaltyMessages.findOutMore} />
      </LoyaltyButton>
    </DescriptionWrapper>
  );
};
